const MAIN_URL = "https://app.viberary.com";
const GA4_MEASUREMENT_ID = "G-63R31Z6Q2C";
//const MAIN_URL = "http://localhost";
// const MAIN_URL = "http://146.190.92.203:90";
// const MAIN_URL = "http://146.190.92.203"
export default {
    MAIN_URL: MAIN_URL,
    GA4_MEASUREMENT_ID: GA4_MEASUREMENT_ID,
}
